export default "__VITE_ASSET__cb52aa7d__"